import { productClient } from '@/js/helpers/backend-clients';
import {
  initialTableState,
  TABLE_HEADERS,
} from '@/store/modules/gekaufte-produkte/listen/list-util';
import { displayAxiosError, hideLoadingOverlay, showLoadingOverlay } from '@/js/helpers/utils';

const state = initialTableState();

const mutations = {
  SET_PAGE_ITEMS(state, payload) {
    state.pageItems = payload;
  },
  SET_TOTAL_ELEMENTS(state, payload) {
    state.totalElements = payload;
  },
  SET_EMPTY_PAGE(state) {
    state.pageItems = [];
  },
  SET_DATATABLE_OPTIONS(state, payload) {
    state.dataTableOptions = payload;
  },
  SET_ITEMS_PER_PAGE(state, payload) {
    state.dataTableOptions.itemsPerPage = payload;
  },
};

const actions = {
  loadPage({ commit, dispatch }, payload) {
    showLoadingOverlay();
    productClient
      .listNdgSaves(payload.page, payload.pageSize, payload.filter)
      .then(({ data }) => {
        if (data) {
          commit('SET_TOTAL_ELEMENTS', data.totalElements);
          commit('SET_PAGE_ITEMS', data.produkte);
        } else {
          commit('SET_EMPTY_PAGE');
        }
      })
      .catch(error => {
        displayAxiosError(error);
      })
      .finally(() => hideLoadingOverlay());
  },
  setDatatableOptions({ commit }, payload) {
    commit('SET_DATATABLE_OPTIONS', payload);
  },
  setItemsPerPage({ commit }, payload) {
    commit('SET_ITEMS_PER_PAGE', payload);
  },
  setItems({ commit }, payload) {
    commit('SET_PAGE_ITEMS', payload);
  },
  setToalElements({ commit }, payload) {
    commit('SET_TOTAL_ELEMENTS', payload);
  },
  setDataTableOptions({ commit }, payload) {
    commit('SET_DATATABLE_OPTIONS', payload);
  },
};
const getters = {
  items: () => {
    return state.pageItems;
  },
  totalElements: () => {
    return state.totalElements;
  },
  dataTableOptions: () => {
    return state.dataTableOptions;
  },
  tableHeaders: () => {
    return TABLE_HEADERS.NDG_SPEICHER_TABLE_HEADERS;
  },
};

const ndgspeicherListeModule = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};

export default ndgspeicherListeModule;
